// import { TextareaAutosize } from "@mui/base";
// import { styled } from "@mui/material";
// import { Field } from "formik";
import React from "react";
import { TextareaAutosize } from "@material-ui/core";
import { styled } from "@mui/material";
import { Field } from "formik";
import { colors } from "../../theme";

const Textarea = styled(TextareaAutosize)(
  () => `
        box-sizing: border-box;
        width: 100%;
        font-family: 'Inter', sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 1.5;
        padding: 12px;
        border-radius: 12px 12px 0 12px;
        color: #009999;
        border: 1px solid ${colors.primaryColor};
      `
);

function BaseTextArea({ name }) {
  return (
    <Field name={name}>
      {({ field, meta }) => (
        <div>
          <Textarea {...field} minRows={6} />
          {meta.touched && meta.error && (
            <div className="error">{meta.error}</div>
          )}
        </div>
      )}
    </Field>
  );
}

export default BaseTextArea;
